export default function (state, getters, rootState) {
    return rootState.finances.certificates.item.form;
}